import useTranslation from 'next-translate/useTranslation';
import { useEffect } from 'react';

import { Translate, timer, util } from '@core/constant';
import { ETimeFormat } from '@core/type';

import { CountDownTimerProps } from './interface-timer';

export const CountDownTimer = ({
  onExpired,
  seconds,
  setSeconds,
  counterDatetime,
  format = ETimeFormat.ss,
}: CountDownTimerProps) => {
  useEffect(() => {
    const timerId = setInterval(() => {
      setSeconds((prevState) => {
        if (prevState > 0) {
          return prevState - 1;
        } else {
          clearInterval(timerId);
          onExpired();
          return 0;
        }
      });
    }, util.MILLISECONDS_IN_SECOND);
    return () => clearInterval(timerId);
  }, [counterDatetime]);

  const time = convertSecondsToTime(seconds);

  const { t } = useTranslation(Translate.common.COMMON);

  switch (format) {
    case ETimeFormat.mmss:
      return `${Math.floor(seconds / util.SECONDS_IN_MINUTE)
        .toString()
        .padStart(timer.NUMBER_TO_SHOW, '0')}:${(seconds % util.SECONDS_IN_MINUTE)
        .toString()
        .padStart(timer.NUMBER_TO_SHOW, '0')}`;
    case ETimeFormat.dhhmmss:
      return `${time.days}${t('timer.d')} ${time.hours
        .toString()
        .padStart(timer.NUMBER_TO_SHOW, '0')}${t('timer.h')} ${time.minutes
        .toString()
        .padStart(timer.NUMBER_TO_SHOW, '0')}${t('timer.m')} ${time.seconds
        .toString()
        .padStart(timer.NUMBER_TO_SHOW, '0')}${t('timer.s')}`;
    case ETimeFormat.ss:
    default:
      return <>{seconds.toString()}</>;
  }
};

function convertSecondsToTime(seconds: number) {
  const days = Math.floor(
    seconds / (util.HOURS_IN_DAY * util.MINUTES_IN_HOUR * util.SECONDS_IN_MINUTE),
  );
  seconds %= util.HOURS_IN_DAY * util.MINUTES_IN_HOUR * util.SECONDS_IN_MINUTE;
  const hours = Math.floor(seconds / (util.MINUTES_IN_HOUR * util.SECONDS_IN_MINUTE));
  seconds %= util.MINUTES_IN_HOUR * util.SECONDS_IN_MINUTE;
  const minutes = Math.floor(seconds / util.SECONDS_IN_MINUTE);
  seconds %= util.SECONDS_IN_MINUTE;

  return {
    days,
    hours,
    minutes,
    seconds: Math.floor(seconds),
  };
}
